import BMFLogo from "../BMFLogo";
import { MMTLogo } from "../CurrencySEOCommonUI";

export default function Header({ currencyData }: any) {
  return (
    <header>
      <div className="headerInner">
        <a href={currencyData?.header?.logo_redirection}>
          <MMTLogo isLight={false} />
        </a>
      </div>
    </header>
  );
}
